import changeReviewerReducer from "./changeReviewerReducer";
import samplingRetestReducer from "./samplingRetestReducer";
import processingListReducer from "./processingListReducer";
import changeProjectManagerReducer from "./changeProjectManagerReducer";
import deletePaymentOrderReducer from "./deletePaymentOrderReducer";
import updateDocumentReducer from "./updateDocumentReducer";

const applicationProcessingReducers = {
    changeReviewer: changeReviewerReducer,
    changeProjectManager: changeProjectManagerReducer,
    samplingRetest: samplingRetestReducer,
    processingList: processingListReducer,
    deletePaymentOrder: deletePaymentOrderReducer,
    updateDocument: updateDocumentReducer,
}

export default applicationProcessingReducers;